<template>
  <div>
    <el-dialog :width="Diawidth" :visible.sync="dataListDialogVisible" v-dialogDrag :before-close="handleClose"
      :close-on-click-modal="true" :show-close="true" :close-on-press-escape="true">
      <span slot='title' class="el-dialog__title">{{ydbInfo.ydbName}}-基本数据比对</span>
      <!-- <el-input class="mhSearch" placeholder="请输入内容" v-model="input" clearable @input="searchInput"></el-input> -->
      <el-table :data="tableData" :row-class-name="rowIndex" border style="width: 100%;" height="530"  :header-cell-style="{background:'rgba(49,130,222,0.1)'}" empty-text="无数据">
        <el-table-column :formatter="order" label="序号" width="60"></el-table-column>
        <el-table-column prop="field" label="字段名">
          <template slot-scope="scope">
              <span v-if="'YDBXIANG' == scope.row.field.toUpperCase()" class="overflowRow">乡</span>
              <span v-else-if=" 'YDBCUN' == scope.row.field.toUpperCase()"  class = "overflowRow">村</span>

              <span v-else-if=" 'YDBNAME' == scope.row.field.toUpperCase()"  class = "overflowRow">淤地坝名称</span>
              <span v-else-if=" 'YDBSFWGGB' == scope.row.field.toUpperCase()"  class = "overflowRow">淤地坝类型</span>
              <span v-else-if=" 'YDBSNZC' == scope.row.field.toUpperCase()"  class = "overflowRow">枢纽组成</span>
              <span v-else-if=" 'YDBSSZL' == scope.row.field.toUpperCase()"  class = "overflowRow">所在流域</span>
              <span v-else-if=" 'YDBJCND' == scope.row.field.toUpperCase()"  class = "overflowRow">建成年代</span>
              <span v-else-if=" 'YDBKZMJ' == scope.row.field.toUpperCase()"  class = "overflowRow">控制面积(km²)</span>
              <span v-else-if=" 'YDBBAGAO' == scope.row.field.toUpperCase()"  class = "overflowRow">坝高(m)</span>
              <span v-else-if=" 'YDBBDCD' == scope.row.field.toUpperCase()"  class = "overflowRow">坝顶长(m)</span>
              <span v-else-if=" 'YDBZKR' == scope.row.field.toUpperCase()"  class = "overflowRow">总库容(万m³)</span>
              <span v-else-if=" 'YDBDHKR' == scope.row.field.toUpperCase()"  class = "overflowRow">滞洪库容(万m³)</span>
              <span v-else-if=" 'YDBSJYJKR' == scope.row.field.toUpperCase()"  class = "overflowRow">设计淤积库容(万m³)</span>
              <span v-else-if=" 'YDBYYKR' == scope.row.field.toUpperCase()"  class = "overflowRow">已淤库容(万m³)</span>
              <span v-else-if=" 'YDBSJYJMJ' == scope.row.field.toUpperCase()"  class = "overflowRow">设计淤积面积(hm²)</span>
              <span v-else-if=" 'YDBYYJMJ' == scope.row.field.toUpperCase()"  class = "overflowRow">已淤积面积(hm²)</span>
              <span v-else-if=" 'YDBJINGDU' == scope.row.field.toUpperCase()"  class = "overflowRow">经度</span>
              <span v-else-if=" 'YDBWEIDU' == scope.row.field.toUpperCase()"  class = "overflowRow">纬度</span>
              <span v-else-if=" 'YDBSFGJ' == scope.row.field.toUpperCase()"  class = "overflowRow">是否改建</span>
              <span v-else-if=" 'YDBSFCXJG' == scope.row.field.toUpperCase()"  class = "overflowRow">是否除险加固</span>
              <span v-else-if=" 'YDBSFLJB' == scope.row.field.toUpperCase()"  class = "overflowRow">是否老旧坝</span>
              <span v-else-if=" 'YDBSFXYYR' == scope.row.field.toUpperCase()"  class = "overflowRow">是否下游有人</span>
              <span v-else-if=" 'YDBBXSLTJ' == scope.row.field.toUpperCase()"  class = "overflowRow">病险数量统计</span>
              <span v-else-if=" 'YDBSFXYGZSJ' == scope.row.field.toUpperCase()"  class = "overflowRow">是否需要改造提升</span>
              <span v-else-if=" 'YDBSFXYXSLY' == scope.row.field.toUpperCase()"  class = "overflowRow">是否需蓄水利用</span>
              <span v-else-if=" 'YDBSFBZYHGBYT' == scope.row.field.toUpperCase()"  class = "overflowRow">是否被占用或改变用途</span>
              <span v-else-if=" 'YDBYXRS' == scope.row.field.toUpperCase()"  class = "overflowRow">影响人数</span>
              <span v-else-if=" 'YDBZYSS' == scope.row.field.toUpperCase()"  class = "overflowRow">重要设施</span>
              <span v-else-if=" 'YDBJKSS' == scope.row.field.toUpperCase()"  class = "overflowRow">监控设施</span>
              <span v-else-if=" 'YDBGLZRZT' == scope.row.field.toUpperCase()"  class = "overflowRow">管理责任主体</span>
              <span v-else-if=" 'YDBYWGHBC' == scope.row.field.toUpperCase()"  class = "overflowRow">管护报酬</span>
              <span v-else-if=" 'YDBBTLF' == scope.row.field.toUpperCase()"  class = "overflowRow">裂缝</span>
              <span v-else-if=" 'YDBBTHPTT' == scope.row.field.toUpperCase()"  class = "overflowRow">滑坡坍塌</span>
              <span v-else-if=" 'YDBBTCQCG' == scope.row.field.toUpperCase()"  class = "overflowRow">冲缺冲沟</span>
              <span v-else-if=" 'YDBBTGYSL' == scope.row.field.toUpperCase()"  class = "overflowRow">管涌、渗漏</span>
              <span v-else-if=" 'YBDFSJZWWGSJ' == scope.row.field.toUpperCase()"  class = "overflowRow">卧管、竖井</span>
              <span v-else-if=" 'YDBFSJZWHDHG' == scope.row.field.toUpperCase()"  class = "overflowRow">涵洞、涵管</span>
              <span v-else-if=" 'YDBFSJZWMQ' == scope.row.field.toUpperCase()"  class = "overflowRow">明渠</span>
              <span v-else-if=" 'YDBXSJZWMQ' == scope.row.field.toUpperCase()"  class = "overflowRow">损毁</span>
              <span v-else-if=" 'YDBXSJZWTSXK' == scope.row.field.toUpperCase()"  class = "overflowRow">淘刷、悬空</span>
              <span v-else-if=" 'YDBDLBT' == scope.row.field.toUpperCase()"  class = "overflowRow">道路不通</span>
              <span v-else-if=" 'YDBLABPBWD' == scope.row.field.toUpperCase()"  class = "overflowRow">两岸边坡不稳定</span>
              <span v-else-if=" 'YDBQTWTSM' == scope.row.field.toUpperCase()"  class = "overflowRow">其他说明问题</span>
              <span v-else-if=" 'YDBXSJZWQT' == scope.row.field.toUpperCase()"  class = "overflowRow">其他</span>
              <span v-else-if=" 'ydbBkmj' == scope.row.field"  class = "overflowRow">坝控面积(km²)</span>
              <span v-else-if=" 'ydbYjdcjd' == scope.row.field"  class = "overflowRow">经度</span>
              <span v-else-if=" 'ydbYjdcwd' == scope.row.field"  class = "overflowRow">纬度</span>
              <span v-else-if=" 'ydbYxsjly' == scope.row.field"  class = "overflowRow">数据来源</span>
              <span v-else-if=" 'ydbYxgcjz' == scope.row.field"  class = "overflowRow">高程基准</span>
              <span v-else-if=" 'ydbYxyymj' == scope.row.field"  class = "overflowRow">已淤面积(h㎡)</span>
              <span v-else-if=" 'ydbYxsykr' == scope.row.field"  class = "overflowRow">整体到坝顶的容积(万m³)</span>
              <span v-else-if=" 'ydbYxyykr' == scope.row.field"  class = "overflowRow">已淤库容(万m³)</span>
              <span v-else-if=" 'ydbYxxskr' == scope.row.field"  class = "overflowRow">水体体积(万m³)</span>
              <span v-else-if=" 'ydbYxbdgc' == scope.row.field"  class = "overflowRow">坝顶高程(m)</span>

              <span v-else-if=" 'ydbYxyjgc' == scope.row.field"  class = "overflowRow">淤积整体平均高程(m)</span>
              <span v-else-if=" 'ydbYxxhssgc' == scope.row.field"  class = "overflowRow">泄洪设施高程(m)</span>
              <span v-else-if=" 'ydbYxbtbsmbjgc' == scope.row.field"  class = "overflowRow">坝体背水面坝脚高程(m)</span>
              <span v-else-if=" 'ydbYxsjjsryxm' == scope.row.field"  class = "overflowRow">数据计算人员姓名</span>
              <span v-else-if=" 'ydbYxsjjsrylxfs' == scope.row.field"  class = "overflowRow">数据计算人员联系方式</span>

              <span v-else-if=" 'ydbScsjly' == scope.row.field"  class = "overflowRow">数据来源(RTK/无人船声呐技术实测获取的指标成果)</span>
              <span v-else-if=" 'ydbScgcjz' == scope.row.field"  class = "overflowRow">高程基准(RTK/无人船声呐技术实测获取的指标成果)</span>
              <span v-else-if=" 'ydbScbtgc' == scope.row.field"  class = "overflowRow">坝顶高程(m)(RTK/无人船声呐技术实测获取的指标成果)</span>
              <span v-else-if=" 'ydbScyjgc' == scope.row.field"  class = "overflowRow">各测点平均高程(m)</span>
              <span v-else-if=" 'ydbScstsd' == scope.row.field"  class = "overflowRow">水体深度(m)</span>
              <span v-else-if=" 'ydbScxhssgd' == scope.row.field"  class = "overflowRow">泄洪设施高程(m)(RTK/无人船声呐技术实测获取的指标成果)</span>
              <span v-else-if=" 'ydbScbtbsmbjgc' == scope.row.field"  class = "overflowRow">坝体背水面坝脚高程(m)(RTK/无人船声呐技术实测获取的指标成果)</span>
              <span v-else-if=" 'ydbScgccjryxm' == scope.row.field"  class = "overflowRow">高程采集人员姓名</span>
              <span v-else-if=" 'ydbScgccjrylxfs' == scope.row.field"  class = "overflowRow">高程采集人员联系方式</span>
              <span v-else-if=" 'ydbScgccjsj' == scope.row.field"  class = "overflowRow">高程采集时间</span>
              <!-- <span v-else-if=" 'ydbSf16788sj' == scope.row.field"  class = "overflowRow">是否16788数据</span> -->
              <span v-else-if=" 'ydbTsqkydb' == scope.row.field"  class = "overflowRow">特殊情况淤地坝</span>
              <span v-else-if=" 'ydbYjqk' == scope.row.field"  class = "overflowRow">淤积情况</span>
              <span v-else-if=" 'ydbSxyysgdwfhq' == scope.row.field"  class = "overflowRow">上下游原始沟底高程无法获取</span>
              <span v-else-if=" 'ydbBppdsfzqhq' == scope.row.field"  class = "overflowRow">边坡坡度是否准确获取</span>
              <span v-else-if=" 'remark' == scope.row.field"  class = "overflowRow">备注</span>
            </template>
        </el-table-column>
        <el-table-column prop="beforeValue" label="修改前">
          <template slot-scope="scope">
              <div v-if="booleanFied.includes(scope.row.field.toUpperCase())">
                <span v-if="scope.row.beforeValue =='0'">否</span>
                <span v-if="scope.row.beforeValue =='1'">是</span>
              </div>
              <div v-else-if="scope.row.field == 'ydbBppdsfzqhq'">
                <span v-if="scope.row.beforeValue =='0'">是</span>
                <span v-if="scope.row.beforeValue =='1'">否</span>
              </div>
              <div v-else-if="scope.row.field == 'ydbYxsjly'">
                <span v-if="scope.row.beforeValue =='0'">卫星遥感影像</span>
                <span v-if="scope.row.beforeValue =='1'">无人机影像</span>
                <span v-if="scope.row.beforeValue == -1 "></span>
              </div>
              <div v-else-if="scope.row.field == 'ydbYxgcjz' || scope.row.field == 'ydbScgcjz'">
                <span v-if="scope.row.beforeValue =='0'">大地高程</span>
                <span v-if="scope.row.beforeValue =='1'">85高程</span>
              </div>
              <div v-else-if="scope.row.field == 'ydbScsjly'">
                <span v-if="scope.row.beforeValue =='0'">RTK测量</span>
                <span v-if="scope.row.beforeValue =='1'">RTK测量辅助无人船声呐技术</span>
                <span v-if="scope.row.beforeValue =='2'">无人机航测辅助无人船声呐技术</span>
              </div>
              <div v-else-if="scope.row.field == 'ydbTsqkydb'">
                <span v-if="scope.row.beforeValue =='0'">淤地坝损毁</span>
                <span v-if="scope.row.beforeValue =='1'">位置信息错误找不见坝</span>
                <span v-if="scope.row.beforeValue =='2'">位置信息重复找不见坝</span>
                <span v-if="scope.row.beforeValue =='3'">人为活动占用</span>
              </div>
              <div v-else-if="scope.row.field == 'ydbYjqk'">
                <span v-if="scope.row.beforeValue =='0'">完全淤平</span>
                <span v-if="scope.row.beforeValue =='1'">接近淤满</span>
                <span v-if="scope.row.beforeValue =='2'">未淤满</span>
              </div>
              <div v-else-if="scope.row.field == 'ydbSxyysgdwfhq'">
                <span v-if="scope.row.beforeValue =='0'">坝系，采用坝高已修正</span>
                <span v-if="scope.row.beforeValue =='1'">坝系，无法修正</span>
                <span v-if="scope.row.beforeValue =='2'">其他，采用坝高已修正</span>
                <span v-if="scope.row.beforeValue =='3'">其他，无法修正</span>
              </div>
              <div v-else>{{ scope.row.beforeValue }}</div>
            </template>
        </el-table-column>
        <el-table-column prop="afterValue" label="修改后">
          <template slot-scope="scope">
              <div v-if="booleanFied.includes(scope.row.field.toUpperCase())">
                <span v-if="scope.row.afterValue =='0'">否</span>
                <span v-if="scope.row.afterValue =='1'">是</span>
              </div>
              <div v-else-if="scope.row.field == 'ydbBppdsfzqhq'">
                <span v-if="scope.row.afterValue =='0'">是</span>
                <span v-if="scope.row.afterValue =='1'">否</span>
              </div>
              <div v-else-if="scope.row.field == 'ydbYxsjly'">
                <span v-if="scope.row.afterValue =='0'">卫星遥感影像</span>
                <span v-if="scope.row.afterValue =='1'">无人机影像</span>
                <span v-if="scope.row.afterValue == '-1'"></span>
              </div>
              <div v-else-if="scope.row.field == 'ydbYxgcjz' || scope.row.field == 'ydbScgcjz'">
                <span v-if="scope.row.afterValue == '0' ">大地高程</span>
                <span v-if="scope.row.afterValue == '1'">85高程</span>
              </div>
              <div v-else-if="scope.row.field == 'ydbScsjly'">
                <span v-if="scope.row.afterValue =='0'">RTK测量</span>
                <span v-if="scope.row.afterValue =='1'">RTK测量辅助无人船声呐技术</span>
                <span v-if="scope.row.afterValue =='2'">无人机航测辅助无人船声呐技术</span>
              </div>
              <div v-else-if="scope.row.field == 'ydbTsqkydb'">
                <span v-if="scope.row.afterValue =='0'">淤地坝损毁</span>
                <span v-if="scope.row.afterValue =='1'">位置信息错误找不见坝</span>
                <span v-if="scope.row.afterValue =='2'">位置信息重复找不见坝</span>
                <span v-if="scope.row.afterValue =='3'">人为活动占用</span>
              </div>
              <div v-else-if="scope.row.field == 'ydbYjqk'">
                <span v-if="scope.row.afterValue =='0'">完全淤平</span>
                <span v-if="scope.row.afterValue =='1'">接近淤满</span>
                <span v-if="scope.row.afterValue =='2'">未淤满</span>
              </div>
              <div v-else-if="scope.row.field == 'ydbSxyysgdwfhq'">
                <span v-if="scope.row.afterValue =='0'">坝系，采用坝高已修正</span>
                <span v-if="scope.row.afterValue =='1'">坝系，无法修正</span>
                <span v-if="scope.row.afterValue =='2'">其他，采用坝高已修正</span>
                <span v-if="scope.row.afterValue =='3'">其他，无法修正</span>
              </div>
              <div v-else>{{ scope.row.afterValue}}</div>
            </template>

        </el-table-column>
        <el-table-column prop="createdByName" label="操作人"></el-table-column>
        <el-table-column prop="createdAt" label="操作时间" ></el-table-column>
      </el-table>

      <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[15, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum">
      </el-pagination> -->
    </el-dialog>
  </div>
</template>

<script>
  import {
    editaudit,
  } from "@/api/api.js";
  export default {
    data() {
      return {
        dataListDialogVisible: true,
        Diawidth: "91%",
        currentPage: 1,
        pageSize: 15,
        tableData: [],
        totalNum: 0,
        input: '',
        title: '',
        booleanFied:['YDBSFGJ','YDBSFCXJG','YDBSFLJB','YDBSFXYYR','YDBSFXYGZSJ','YDBSFXYXSLY','YDBSFBZYHGBYT','YDBBTLF','YDBBTCQCG','YDBBTGYSL','YDBFSJZWMQ','YDBXSJZWMQ',
        'YDBXSJZWTSXK','YDBXSJZWQT','YDBDLBT','YDBLABPBWD','YBDFSJZWWGSJ','YDBBTHPTT','YDBFSJZWHDHG']
      }
    },
    props: ["ydbInfo"],
    mounted() {
      this.dataList();
    },
    methods: {
      dbClick(row) {
        let params = {
          ydbCode: row.ydbCode
        };
        ydbjbxxsearch(params).then((res) => {
          this.$emit("queryDatas", res.data);
          this.$store.commit('queryData', res.data); //token
          this.cancel();
        });
      },

      dataList() {
        editaudit({
          ydbCode:this.ydbInfo.ydbCode,
          dataId: this.ydbInfo.id
        }).then((res) => {
          // console.log(res)
          this.totalNum = res.total;
          this.tableData = res.data;
        });
      },

      searchInput(value) {
        let params;
        if (value != '') {
          if (this.$store.state.ydbryorssShow == false) {
            params = {
              ydbName: value,
              ydbCode: this.ClickName[0].code,
              generalField: this.ClickName[0].sectionName,
              pageNum: this.currentPage,
              pageSize: this.pageSize
            };
          } else {
            params = {
              ydbName: value,
              ydbCode: this.ClickName[0].code,
              generalField: this.ClickName[0].sectionName,
              pageNum: this.currentPage,
              pageSize: this.pageSize,
              ydbCodeList: this.$store.state.myydbData.split(',')
            };
          }
        } else {
          if (this.$store.state.ydbryorssShow == false) {
            params = {
              ydbCode: this.ClickName[0].code,
              generalField: this.ClickName[0].sectionName,
              pageNum: this.currentPage,
              pageSize: this.pageSize
            };
          } else {
            params = {
              ydbCode: this.ClickName[0].code,
              generalField: this.ClickName[0].sectionName,
              pageNum: this.currentPage,
              pageSize: this.pageSize,
              ydbCodeList: this.$store.state.myydbData.split(',')
            };
          }
        }
        this.ydbInfoForRegionFun(params);
      },

      handleClose() {
      this.dataListDialogVisible= false;
        this.$emit("getcancel");   
    },

      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.pageSize = val;
        this.dataList();
      },

      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.currentPage = val;
        this.dataList();
      },

      rowIndex({
        row,
        rowIndex
      }) {
        row.rowIndex = rowIndex;
      },

      order(row) {
        return this.pageSize * (this.currentPage - 1) + row.rowIndex + 1;
      }
    }
  }
</script>

<style scoped>
  >>>.el-dialog {
    height: 700px;
    /* background: url(../../../common/images/dialog.png) no-repeat center; */
    background-size: 100% 100%;
  }

  >>>.el-dialog__body {
    height: 560px;
    padding: 5px 10px;
  }

  >>>.el-dialog__header {
    /* border: none; */
    padding-left: 0;
    margin: 10px 20px 8px 20px;
  }

  >>>.el-dialog__body, .el-dialog__footer{
      /* background: transparent; */
  }

  .mhSearch {
    position: absolute;
    top: 0;
    right: 80px;
    width: 200px;
    margin-top: 18px;
    transform: translate(-50%);
  }

  >>>.el-input__inner {
    height: 25px;
    line-height: 25px;
  }

  >>>.el-input__suffix {
    height: 25px;
    line-height: 25px;
  }

  >>>.el-input__icon {
    height: 25px;
    line-height: 25px;
  }

  /*  */
</style>
